<script>
    import Header from "../header.svelte"
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import {link, location, push, pop, replace} from 'svelte-spa-router';

    let is_busy = false;
    let content_title = "Settings - Notification"


</script>

<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">


    <div class="buttonholder">
        <button class="savebutton" on:click={() => {console.log("hello");}} ><i class="far fa-save"></i> Save Settings</button>
    </div>
    
</div>


<style>
.buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        /* width: 100%; */
        /* background-color: #357a38; */
        /* color: white; */
    }
    .buttonholder button.savebutton {
        color: white;
        background-color: #357a38;
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
    }

</style>